import { render, staticRenderFns } from "./daily_trip_vehicle.vue?vue&type=template&id=62470ce8&scoped=true"
import script from "./daily_trip_vehicle.vue?vue&type=script&lang=js"
export * from "./daily_trip_vehicle.vue?vue&type=script&lang=js"
import style0 from "./daily_trip_vehicle.vue?vue&type=style&index=0&id=62470ce8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62470ce8",
  null
  
)

export default component.exports